<template>
    <form @submit.prevent="saveChapter" class="chapter-form">
      <div class="form-group">
        <label for="chapterTitle">Judul Bab <span class="required">*</span></label>
        <input
          type="text"
          id="chapterTitle"
          v-model="formData.title"
          required
          placeholder="Masukkan judul bab"
          :class="{'error-input': errors.title}"
        />
        <span v-if="errors.title" class="error-message">{{ errors.title }}</span>
      </div>
      
      <div class="form-group">
        <label for="chapterOrder">Urutan Bab <span class="required">*</span></label>
        <input
          type="number"
          id="chapterOrder"
          v-model="formData.order_number"
          required
          min="1"
          placeholder="Urutan bab"
          :class="{'error-input': errors.order_number}"
        />
        <span v-if="errors.order_number" class="error-message">{{ errors.order_number }}</span>
        <span class="input-hint">Bab dengan urutan 1-2 dapat dibaca oleh pengguna gratis</span>
      </div>
      
      <div class="form-group content-editor">
        <label for="chapterContent">Konten <span class="required">*</span></label>
        <TinyMceEditor
          v-model="formData.content"
          :placeholder="'Tulis konten bab di sini...'"
          :height="600"
          ref="chapterEditor"
        />
        <span v-if="errors.content" class="error-message">{{ errors.content }}</span>
      </div>
      
      <div class="form-actions">
        <button type="button" @click="cancel" class="btn-cancel">Batal</button>
        <button type="submit" class="btn-primary" :disabled="isSubmitting">
          <font-awesome-icon v-if="isSubmitting" :icon="['fas', 'spinner']" spin />
          {{ isSubmitting ? 'Menyimpan...' : submitButtonText }}
        </button>
      </div>
    </form>
  </template>
  
  <script>
  import TinyMceEditor from '@/components/SimpleHtmlEditor.vue';
  
  export default {
    name: 'ChapterForm',
    components: {
      TinyMceEditor
    },
    props: {
      initialData: {
        type: Object,
        default: () => ({
          title: '',
          order_number: 1,
          content: ''
        })
      },
      errors: {
        type: Object,
        default: () => ({})
      },
      isSubmitting: {
        type: Boolean,
        default: false
      },
      submitButtonText: {
        type: String,
        default: 'Simpan Bab'
      }
    },
    data() {
      return {
        formData: {
          title: '',
          order_number: 1,
          content: ''
        }
      };
    },
    watch: {
      initialData: {
        handler(newVal) {
          this.formData = { ...newVal };
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      saveChapter() {
        // Validasi dasar
        if (!this.formData.title.trim()) {
          this.$emit('update:errors', { ...this.errors, title: 'Judul bab harus diisi' });
          return;
        }
        
        if (!this.formData.content.trim()) {
          this.$emit('update:errors', { ...this.errors, content: 'Konten bab harus diisi' });
          return;
        }
        
        this.$emit('save', { ...this.formData });
      },
      cancel() {
        this.$emit('cancel');
      }
    }
  };
  </script>
  
  <style scoped>
  .chapter-form {
    width: 100%;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
  }
  
  .form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 16px;
  }
  
  .input-hint {
    display: block;
    font-size: 12px;
    color: #777;
    margin-top: 5px;
  }
  
  .required {
    color: #e74c3c;
  }
  
  .error-input {
    border-color: #e74c3c !important;
  }
  
  .error-message {
    display: block;
    color: #e74c3c;
    font-size: 14px;
    margin-top: 5px;
  }
  
  .content-editor {
    margin-bottom: 30px;
  }
  
  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 30px;
  }
  
  .btn-primary {
    background-color: #488e71;
    color: white;
    border: none;
    padding: 12px 25px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .btn-primary:hover {
    background-color: #3a7259;
  }
  
  .btn-primary:disabled {
    background-color: #93c3b1;
    cursor: not-allowed;
  }
  
  .btn-cancel {
    background-color: #f1f1f1;
    color: #333;
    border: none;
    padding: 12px 25px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
  }
  
  .btn-cancel:hover {
    background-color: #e9e9e9;
  }
  
  @media (max-width: 768px) {
    .form-actions {
      flex-direction: column;
    }
    
    .form-actions button {
      width: 100%;
    }
  }
  :deep(.tox-edit-area__iframe) {
    direction: ltr !important;
    text-align: left !important;
  }
  </style>